import React, { useEffect, useState, Suspense } from 'react'
import { getUser } from '../../users/actions/user'
import { countryIds } from '../../../components/_utils/appUtils'
import _ from 'lodash'

const MarketingUserInfo = React.lazy(() => import('../components/marketingUserInfo'))
const UniversityWiseReportComponent = React.lazy(() => import('../components/universityWiseReportComponent'))
const MarketingUserWiseUniversityReport = React.lazy(() => import('../marketingUserWiseUniversityReport'))
const MeetingRecordGraph = React.lazy(() => import('../components/meetingRecordGraph'))
const ExpenseRecordGraph = React.lazy(() => import('../components/expenseRecordGraph'))
const TopAgentVisaRecordGraph = React.lazy(() => import('../components/topAgentVisaRecordGraph'))
const StateWiseRecords = React.lazy(() => import('../components/stateWiseRecords'))
const VisaChart10DayCount = React.lazy(() => import('../../dashboard/components/visaChart10DayCount'))
const UkStudentYearWise = React.lazy(() => import('../../dashboard/components/UkStudentYearWise'))

const MarketingManagerDashboard = (props) => {
    let { dispatch } = props
    let [currentUserId, setCurrentUserId] = useState('')
    let [showUkStudentGraph, setShowUkStudentGraph] = useState(false)

    let user = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user'))
      : null
    useEffect(() => {
        loadUrl()
    }, [])
    let loadUrl = () => {
        let searchParams = new URLSearchParams(window.location.search)
        let userId = searchParams.get('id')
        if (userId) {
            setCurrentUserId(userId)
        }
    }


    useEffect(() => {
        loadUserData()
    }, [currentUserId])

    const loadUserData = async () => {
        let userId = user._id
        if (currentUserId) {
            userId = currentUserId
        }
        let data = await dispatch(getUser(userId))
        if (data && data._id) {
            let findUk = _.find(data.marketingCountries, (item) => {
                return item && item.countryId && item.countryId._id && item.countryId._id.toString() == countryIds.uk
            })
            if (findUk && findUk.countryId) {
                setShowUkStudentGraph(true)
            }
        }
    }


    return (
      <>

          <div key={currentUserId}>
              <Suspense fallback={<></>}>
                  <MarketingUserInfo userId={currentUserId ? currentUserId : user._id} />
              </Suspense>
              {showUkStudentGraph ? <Suspense fallback={<></>}>
                  <div className={'mt20'}>
                      <UkStudentYearWise />
                  </div>
              </Suspense> : null}
              <Suspense fallback={<></>}>
                  <UniversityWiseReportComponent currentUserId={currentUserId} />
              </Suspense>
              <Suspense fallback={<></>}>
                  <MarketingUserWiseUniversityReport currentUserId={currentUserId} />
              </Suspense>
              <Suspense fallback={<></>}>
                  <MeetingRecordGraph currentUserId={currentUserId} />
              </Suspense>
              <Suspense fallback={<></>}>
                    <ExpenseRecordGraph currentUserId={currentUserId} />
                </Suspense>
                <Suspense fallback={<></>}>
                    <TopAgentVisaRecordGraph currentUserId={currentUserId} />
                </Suspense>
                <Suspense fallback={<></>}>
                    <StateWiseRecords currentUserId={currentUserId} />
                </Suspense>
                {/*<Suspense fallback={<></>}>
                    <VisaChart10DayCount user={user} />
                </Suspense>*/}
            </div>
        </>
    )
}
export default MarketingManagerDashboard
